import { Eyebrow, Reveal } from './Reveal';

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="scroll-mt-28 bg-white pb-20 lg:pb-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow index="05">Our Team</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
              The People Behind <span className="text-royal">Sania Job Bowl</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
              The Bengaluru team behind our recruitment, staffing and payroll operations.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative mt-12">
            <div aria-hidden="true" className="absolute -right-4 -top-4 h-full w-full rounded-[2rem] border-2 border-lime" />
            <div className="group relative overflow-hidden rounded-[2rem] shadow-lift ring-1 ring-slate-200/80">
              <img
                src="/assets/team.jpg"
                alt="The Sania Job Bowl team at their Bengaluru office"
                data-testid="team-photo"
                className="aspect-[16/9] w-full object-cover object-[50%_30%] transition-transform duration-700 ease-out group-hover:scale-[1.02]"
                loading="lazy"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
